import { usePrices } from "../hooks/use-prices";
import { useProductExtras } from "../hooks/use-product-extras";

export const getPetiteDecorationPrice = () => {

  const prices = usePrices();
  const products = useProductExtras();
  const petiteDecoration = products.find(x => x.name === "Petite Decoration");

  const cakePrices = prices.filter(x => x.product.id === petiteDecoration.id);
  const options = cakePrices.map(x => { return { id: x.id, size: x.description, price: (x.unit_amount) / 100 }; })

  return options[0];

}
